import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { Card } from "react-md";
import MGrid, { FILTER_TYPE_NONE } from "components/Shared/MGrid.tsx";
import { MSpinner } from "components/Shared";

class CaseAttributesReduxCard extends React.Component {

  render() {
    // Case Attributes are fetched in CaseDetails component
    if (this.props.isFetchingCaseAttributes) {
      return <MSpinner />;
    }

    // 7 Rows of attributes fit cleanly without any need to set grid height
    const adjustGridHeight = this.props.caseAttributes?.length > 7;
    let gridHeight;
    if (adjustGridHeight) {
      // Rows are 35 px tall but we need to add extra to get all items to show and this decreases per row
      // TODO: when there's more time fix all the grid styles so we don't need a magic number here
      let heightPerRow = Math.max(-1 * this.props.caseAttributes.length + 61, 40);
      gridHeight = heightPerRow * this.props.caseAttributes.length;
    }

    return (
      <Card className={`card-unnested profile-card card-style`}>
        <div
          className="grid-card"
          style={{
            height: "100%",
          }}
        >
          <MGrid
            headerText="Case Attributes"
            columnDefinitions={[
              {
                key: "name",
                name: "Name",
                dataSource: "name",
                filterType: FILTER_TYPE_NONE,
                sortable: false,
                resizable: true
              },
              {
                key: "value",
                name: "Value",
                dataSource: "value",
                filterType: FILTER_TYPE_NONE,
                sortable: false,
                resizable: true
              }
            ]}
            data={this.props.caseAttributes}
            displayNumOfItemsFound={false}
            height={adjustGridHeight ? gridHeight : null}
          />
        </div>
      </Card>
    );
  }
}

CaseAttributesReduxCard.propTypes = {
  caseAttributes: PropTypes.array.isRequired,
  isFetchingCaseAttributes: PropTypes.bool.isRequired,  
};

const mapStateToProps = state => {
  return {
    isFetchingCaseAttributes: state.caseForms.isFetchingCaseAttributes,
    caseAttributes: state.caseForms.caseAttributes
  };
};

export default withRouter(connect(mapStateToProps, null)(CaseAttributesReduxCard));
